import { render } from "./ScreenIcon.vue?vue&type=template&id=1c9eee1e&ts=true"
import script from "./ScreenIcon.vue?vue&type=script&lang=ts"
export * from "./ScreenIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__